import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

const mainContainerBase = {
  fontSize: vh(2.083),
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '15vh',
  width: '67.5vw',
  backgroundColor: themeColor.lightBackground,
  outline: 0,
  fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
  fontStretch: 'normal',
  fontStyle: 'normal',
  letterSpacing: '1.2px',
};

export const styles = makeStyles(theme => ({
  main: {
    ...mainContainerBase,
  },
  dobMain: {
    ...mainContainerBase,
    width: '50vw',
  },
  barError: {
    backgroundColor: themeColor.alert,
  },
  bar: {
    width: '4.4vw',
    height: '1.31vh',
    margin: 'auto',
  },
  barPadding: {
    paddingBottom: '3.91vh',
  },
  ageText: {
    textAlign: 'center',
    paddingBottom: '3.91vh',
  },
  inner: {
    paddingLeft: '2vw',
    width: '100%',
    paddingBottom: '5vh',
  },
  innerInverse: {
    paddingLeft: '2vw',
    paddingBottom: '5vh',
  },
  innerTitle: {
    backgroundColor: 'white',
    width: '100%',
  },
  contentTitle: {
    fontSize: vh(3.125),
    fontWeight: 500,
    lineHeight: 'normal',
    color: themeColor.modalTitle,
    paddingTop: '2.5vh',
    paddingBottom: '2.5vh',
    paddingLeft: '2.5vh',
  },
  instructionTitle: {
    fontSize: vh(2.604),
    fontWeight: 500,
    lineHeight: 'normal',
    color: themeColor.modalTitle,
  },
  iconLabelContainer: {
    alignItems: 'center',
  },
  iconLabel: {
    height: '2.34vh',
    width: '1.97vw',
  },
  scanDriversLicenseContainer: {
    marginTop: '4vw',
    marginBottom: '2vw',
    marginLeft: '8vw',
  },
  enterDateManually: {
    marginBottom: '2vw',
    marginLeft: '8vw',
  },
  enterDateManuallyContainer: {
    flexWrap: 'nowrap',
  },
  scanDriversLicenseText: {
    marginLeft: '0.44vw',
    color: themeColor.palesky,
  },
  checkIdInstruction: {
    marginTop: '2vh',
    marginRight: '1vw',
  },
  checkIdInfoText: {
    color: themeColor.blackish,
    textAlign: 'center',
    padding: '0 .88vw 0 .88vw',
  },
  checkIdInstructionWrapper: {
    width: '100%',
    textAlign: 'center',
    color: themeColor.palesky,
  },
  checkIdInstructionText: {
    color: themeColor.palesky,
    paddingLeft: '10%',
    paddingRight: '10%',
  },
  rejectReason: {
    height: '7.29vh',
    width: '30.82vw',
  },
  actionButtonsContainer: {
    paddingLeft: '1.4641288433382138vw',
    paddingRight: '1.4641288433382138vw',
    paddingBottom: '2.6041666666666665vh',
    justifyContent: 'space-between',
    backgroundColor: themeColor.verylightgrey,
  },
  approveRejectButtonsContainer: {
    display: 'flex',
  },
  nestedButtonsContainer: {
    display: 'flex',
    padding: '4vh 0px 2vh 0px',
    flex: '1 0 100%',
  },
  bottomContainer: {
    alignSelf: 'flex-end',
    paddingTop: '35vh',
  },
  cancelButtonContainer: {
    alignSelf: 'flex-start',
    paddingTop: '22vh',
  },
  dobApproveRejectCancelButtonContainer: {
    alignSelf: 'flex-start',
  },
  cancelButton: {
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    '& .label': {
      fontSize: vh(2.08),
      letterSpacing: '1.25px',
      color: themeColor.defaultTextColor,
    },
  },
  icon: {
    display: 'inline-block',
    height: '2.8vh',
    width: '2.3vw',
    color: themeColor.alert,
  },
  errorMessage: {
    fontSize: vh(2.35),
    color: theme.palette.info.dark,
    marginLeft: '0.6vw',
    fontWeight: 500,
  },
  formError: {
    width: '100%',
    marginTop: '1.5vh',
  },
  rejectButtonGridItem: {
    paddingRight: '2.2vw',
  },
  rejectButtonGridItemInverse: {
    paddingLeft: '2.2vw',
  },
  rejectButton: {
    backgroundColor: themeColor.alert,
    '&:hover': {
      backgroundColor: themeColor.alert,
    },
    '& .label': {
      fontSize: vh(2.08),
      letterSpacing: '1.25px',
      color: themeColor.white,
    },
  },
  approveButton: {
    backgroundColor: themeColor.darkGreen,
    '&:hover': {
      backgroundColor: themeColor.secondaryContrast,
    },
    '& .label': {
      fontSize: vh(2.08),
      letterSpacing: '1.25px',
      color: themeColor.white,
    },
  },
  keypadGridItem: {
    alignSelf: 'flex-end',
    paddingBottom: '2.3vh',
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  selectLabel: {
    '&.Mui-focused': {
      color: theme.palette.primary.dark,
    },
  },
  outlinedInput: {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    placeContent: 'center',
  },
  border: {
    color: themeColor.darkerlightgray,
    width: '33.6%',
    margin: 'unset',
  },
  transactionLogo: {
    fill: themeColor.secondaryMain,
  },
  paddingIcon: {
    paddingRight: '2.49vw',
  },
  iconContainer: {
    padding: '1.48vh 0 3.43vh 0',
  },
  dividerContainer: {
    paddingBottom: '3.26vh',
    width: '100%',
  },
}));
